import { Component } from "@basic-orange/component";

export default class InpageNavigation extends Component {
    constructor(elm, componentId) {
        super(elm, componentId);

        setTimeout(() => {
            if (Foundation.MediaQuery.atLeast('xmedium')) {
                this.$elm = $(elm);
                this.elmBoundingBox = $.rectangle(elm);
                this.$article = $('article');
                this.$header = $('.header');

                this.stickyPoint = this.$elm.offset().top;

                this.dirIsUpClass = 'toptask--isInpageNavigation--dirIsUp';
                this.dirIsDownClass = 'toptask--isInpageNavigation--dirIsDown';
                this.dirIsActiveClass = 'toptask--isInpageNavigation--dirIsActive';

                this.setEventListeners();

                this.init();
            }
        }, 1000);
    }

    init() {
        setTimeout(() => {
            var scrollPosition = $(window).scrollTop() + 1;
            $(window).scrollTo(scrollPosition, 1);

            if (window.location.hash) {
                setTimeout(() => {
                    this.$elm.find(`.toptask--isInpageNavigation[href="${window.location.hash}"]`).trigger('click');
                }, 200);
            }
        }, 400);
    }

    setEventListeners() {
        this.$elm.find('.toptask--isInpageNavigation').on('click', this.onLinkClick.bind(this));

        $(window)
            .on('scroll', this.onScroll.bind(this));
    }

    checkSectionStates(headerBoundingBox, elmBoundingBox) {
        $('.InpageNavigation-section').each(function(i, elm) {
            let $section = $(elm);

            let sectionBoundingBox = $.rectangle(elm);
            let id = $section.attr('id');
            let offset = (headerBoundingBox.height + elmBoundingBox.height) + 20;
            offset = offset - (offset * 2);

            let dirIsUp = sectionBoundingBox.top + offset < 0;
            let dirIsDown = sectionBoundingBox.top + offset > (0 - sectionBoundingBox.height);
            let sectionIsActive = dirIsUp && dirIsDown;

            let cssClass = "";
            if (dirIsUp) {
                cssClass += ` ${this.dirIsUpClass}`;
            }
            if (dirIsDown) {
                cssClass += ` ${this.dirIsDownClass}`;
            }
            if (sectionIsActive) {
                cssClass += ` ${this.dirIsActiveClass}`;

                this.updateSectionInUrl(id);
            }

            $(`.toptask--isInpageNavigation[href="#${id}"]`)
                .removeClass(this.dirIsUpClass)
                .removeClass(this.dirIsDownClass)
                .removeClass(this.dirIsActiveClass)
                .addClass(cssClass);

        }.bind(this));
    }

    updateSectionInUrl(section) {
        history.replaceState(null, null, `#${section}`);
    }

    onLinkClick(event) {
        event.preventDefault();
        var $target = $(event.target).closest('.toptask--isInpageNavigation');
        var href = $target.attr("href");
        var section = href.replace('#', '');

        var headerBoundingBox = $.rectangle($("header"));
        var elmBoundingBox = $.rectangle(this.elm);

        var offset = (headerBoundingBox.height + elmBoundingBox.height) + 20;

        $(window).scrollTo($(href), 200, {
            offset: offset - (offset * 2),
            onAfter: () => { this.updateSectionInUrl(section); }
        });
    }

    onScroll(event) {
        var scrollTop = $(window).scrollTop();
        var headerBoundingBox = $.rectangle($("header"));
        var elmBoundingBox = $.rectangle(this.elm);

        this.checkSectionStates(headerBoundingBox, elmBoundingBox);

        //var scrollDirectionIsDown = (scrollTop > this.lastScrollTop);

        if (scrollTop > this.stickyPoint) {
            this.$elm
                .css({ marginTop: headerBoundingBox.height + 'px'})
                .addClass('InPageNavigation--isSticky');

            this.$article.css({ marginTop: (headerBoundingBox.height + elmBoundingBox.height + 64) + 'px' });
            this.$header.addClass('header--inpageNavigationIsFixed');
        } else {
            this.$elm
                .css({ marginTop: 0 })
                .removeClass('InPageNavigation--isSticky');

            this.$article.css({ marginTop: 0 });
            this.$header.removeClass('header--inpageNavigationIsFixed');
        }

        this.lastScrollTop = scrollTop;
    }
}